
export interface DesignData {
  logo: {
    type: "common" | "custom",
    url: string,
  },
  title: string,
  description: string,
}

export class Design{

  enable: boolean = false;
  data?: DesignData

  constructor(object = null){
    if(object){
      this.set(object);
    }
  };

  set(object:any){
    if(object.enable != null){
      this.enable = object.enable as boolean;
    }
    if(object.data){
      this.data = {
        title: object.data.title,
        description: object.data.description,
        logo: object.data.logo ?? null,
      };
    }
  }
}
  